import "./App.css";
import "./responsive.css";
import { Switch, Route } from "react-router-dom";
import Home from "./components/Landing/Index";
import Account from "./components/accounts/Index";
import ApiLoader from "./utility/ApiLoader";
import { connect } from "react-redux";
import { NotificationContainer } from "react-notifications";
import Landing from "./components/dashboard/Landing";
import AdminLogin from "./components/Restricted/accounts/Index";
import Sectors from "./components/Restricted/sectors/Index";
import ExtFilter from "./components/RestrictedExt/sectors/Index";
// import Feedback from "./components/Restricted/feedbacks/Index";
import Reset from "./components/accounts/Password/Reset";
import Confirm from "./components/accounts/Password/Confirm";

// Global admin pages (EXMANAF)
import AdminLayout from "./components/layout/admin/Layout";
import GlobalOverview from "./components/Restricted/global/GlobalOverview";
import AllAgents from "./components/Restricted/global/AllAgents";
import AllMerchants from "./components/Restricted/global/AllMerchants";
import SalesAdmins from "./components/Restricted/global/SalesAdmins";
import Wallets from "./components/Restricted/global/Wallets";
import AllFeedbacks from "./components/Restricted/global/AllFeedbacks";
import AdminSectors from "./components/Restricted/global/AdminSectors";
import PaymentsDashboard from "./components/Restricted/payments/PaymentsDashboard";
import AllTransactions from "./components/Restricted/payments/AllTransactions";
import Settlements from "./components/Restricted/payments/Settlements";
import Disputes from "./components/Restricted/payments/Disputes";
import Refunds from "./components/Restricted/payments/Refunds";
import SubscriptionPlans from "./components/Restricted/subscriptions/SubscriptionPlans";
import MerchantSubscriptions from "./components/Restricted/subscriptions/MerchantSubscriptions";
import WalletDetail from "./components/Restricted/wallets/WalletDetail";
import SeerbitWallets from "./components/Restricted/seerbit/SeerbitWallets";
import SeerbitWalletDetail from "./components/Restricted/seerbit/SeerbitWalletDetail";
import TierUpgradeRequests from "./components/Restricted/seerbit/TierUpgradeRequests";
import BusinessUpgradeRequests from "./components/Restricted/seerbit/BusinessUpgradeRequests";
import PosRequests from "./components/Restricted/seerbit/PosRequests";
import SeerbitSettings from "./components/Restricted/seerbit/SeerbitSettings";
import SeerbitFees from "./components/Restricted/seerbit/SeerbitFees";
import Earnings from "./components/Restricted/earnings/Earnings";
import PayoutManagement from "./components/Restricted/payouts/PayoutManagement";
import SupportTickets from "./components/Restricted/support/SupportTickets";
import TicketDetail from "./components/Restricted/support/TicketDetail";
import AppFeedbacks from "./components/Restricted/support/AppFeedbacks";

// External Sales Access
import RestrictedExt from "./components/RestrictedExt/Index";
import AdminLoginExt from "./components/RestrictedExt/accounts/Index";
import ExtAgents from "./components/RestrictedExt/agents/Index";
import ExtMerchants from "./components/RestrictedExt/merchants/Index";
import ExtFeedbacksPage from "./components/RestrictedExt/feedbacks/Index";
import ExtReferral from "./components/RestrictedExt/referral/Index";
import ExtSettings from "./components/RestrictedExt/settings/Index";

function AdminPage({ Content }) {
  return (
    <AdminLayout>
      <Content />
    </AdminLayout>
  );
}

// Stable references defined at module scope so App re-renders never create new
// function identities, which would cause React Router to unmount/remount the
// entire subtree on every Redux state change (infinite request loop).
const GlobalOverviewPage = () => <AdminPage Content={GlobalOverview} />;
const AllAgentsPage = () => <AdminPage Content={AllAgents} />;
const AllMerchantsPage = () => <AdminPage Content={AllMerchants} />;
const SalesAdminsPage = () => <AdminPage Content={SalesAdmins} />;
const WalletsPage = () => <AdminPage Content={Wallets} />;
const AllFeedbacksPage = () => <AdminPage Content={AllFeedbacks} />;
const PaymentsDashboardPage = () => <AdminPage Content={PaymentsDashboard} />;
const AllTransactionsPage = () => <AdminPage Content={AllTransactions} />;
const SettlementsPage = () => <AdminPage Content={Settlements} />;
const DisputesPage = () => <AdminPage Content={Disputes} />;
const RefundsPage = () => <AdminPage Content={Refunds} />;
const SubscriptionPlansPage = () => <AdminPage Content={SubscriptionPlans} />;
const MerchantSubscriptionsPage = () => (
  <AdminPage Content={MerchantSubscriptions} />
);
const WalletDetailPage = () => <AdminPage Content={WalletDetail} />;
const SeerbitWalletsPage = () => <AdminPage Content={SeerbitWallets} />;
const SeerbitWalletDetailPage = () => <AdminPage Content={SeerbitWalletDetail} />;
const TierUpgradeRequestsPage = () => <AdminPage Content={TierUpgradeRequests} />;
const BusinessUpgradeRequestsPage = () => <AdminPage Content={BusinessUpgradeRequests} />;
const PosRequestsPage = () => <AdminPage Content={PosRequests} />;
const SeerbitSettingsPage = () => <AdminPage Content={SeerbitSettings} />;
const SeerbitFeesPage = () => <AdminPage Content={SeerbitFees} />;
const EarningsPage = () => <AdminPage Content={Earnings} />;
const PayoutManagementPage = () => <AdminPage Content={PayoutManagement} />;
const SupportTicketsPage = () => <AdminPage Content={SupportTickets} />;
const TicketDetailPage = () => <AdminPage Content={TicketDetail} />;
const AppFeedbacksPage = () => <AdminPage Content={AppFeedbacks} />;

function PrivateRoute({ component: Component, authed, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        authed === true ? (
          <Component {...props} />
        ) : (
          window.location.assign("/accounts?q=login")
        )
      }
    />
  );
}

function PrivateRouteAdmin(props) {
  const { component: Component, authed, ...rest } = props;
  return (
    <Route
      {...rest}
      render={(props1) => {
        return authed === true ? (
          <Component {...props1} />
        ) : (
          window.location.assign("/admin/accounts?q=login")
        );
      }}
    />
  );
}

function PrivateRouteExt({ component: Component, authed, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        authed === true ? (
          <Component {...props} />
        ) : (
          window.location.assign("/sales-admin/accounts?q=login")
        )
      }
    />
  );
}

function App({ token, isLogged, auth }) {
  return (
    <>
      <Switch>
        <Route exact path='/' component={Home}></Route>
        <Route exact path='/accounts' component={Account}></Route>
        <Route exact path='/admin/accounts' component={AdminLogin}></Route>
        <Route
          exact
          path='/sales-admin/accounts'
          component={AdminLoginExt}
        ></Route>
        <Route exact path='/password-reset' component={Reset}></Route>
        <Route exact path='/reset' component={Confirm}></Route>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin'
          component={GlobalOverviewPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/agents'
          component={AllAgentsPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/merchants'
          component={AllMerchantsPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/sales-admins'
          component={SalesAdminsPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/wallets'
          component={WalletsPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/feedbacks'
          component={AllFeedbacksPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/sectors'
          component={() => <AdminPage Content={AdminSectors} />}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/filter'
          component={Sectors}
        ></PrivateRouteAdmin>
        {/* <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/feedback'
          component={Feedback}
        ></PrivateRouteAdmin> */}
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/payments'
          component={PaymentsDashboardPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/payments/transactions'
          component={AllTransactionsPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/payments/settlements'
          component={SettlementsPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/payments/disputes'
          component={DisputesPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/payments/refunds'
          component={RefundsPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/subscriptions'
          component={SubscriptionPlansPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/subscriptions/merchants'
          component={MerchantSubscriptionsPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/wallets/:userId'
          component={WalletDetailPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/seerbit/wallets'
          component={SeerbitWalletsPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/seerbit/wallets/:userId'
          component={SeerbitWalletDetailPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/seerbit/tier-requests'
          component={TierUpgradeRequestsPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/seerbit/business-requests'
          component={BusinessUpgradeRequestsPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/seerbit/pos-requests'
          component={PosRequestsPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/seerbit/settings'
          component={SeerbitSettingsPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/seerbit/fees'
          component={SeerbitFeesPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/earnings'
          component={EarningsPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/payouts'
          component={PayoutManagementPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/support-tickets'
          component={SupportTicketsPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/support-tickets/:id'
          component={TicketDetailPage}
        ></PrivateRouteAdmin>
        <PrivateRouteAdmin
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EXMANAF"
          }
          path='/admin/app-feedbacks'
          component={AppFeedbacksPage}
        ></PrivateRouteAdmin>
        <PrivateRoute
          exact
          authed={
            isLogged && token.length > 0 && auth.auth.userType === "EX20AG"
          }
          path='/console'
          component={Landing}
        />
        {/* External Sales Private Route */}
        <PrivateRouteExt
          exact
          authed={
            isLogged &&
            token.length > 0 &&
            auth.auth.userType === "EX-DSA-EXT-ADMIN"
          }
          path='/sales-admin'
          component={RestrictedExt}
        ></PrivateRouteExt>
        <PrivateRouteExt
          exact
          authed={
            isLogged &&
            token.length > 0 &&
            auth.auth.userType === "EX-DSA-EXT-ADMIN"
          }
          path='/sales-admin/filter'
          component={ExtFilter}
        ></PrivateRouteExt>
        <PrivateRouteExt
          exact
          authed={
            isLogged &&
            token.length > 0 &&
            auth.auth.userType === "EX-DSA-EXT-ADMIN"
          }
          path='/sales-admin/agents'
          component={ExtAgents}
        ></PrivateRouteExt>
        <PrivateRouteExt
          exact
          authed={
            isLogged &&
            token.length > 0 &&
            auth.auth.userType === "EX-DSA-EXT-ADMIN"
          }
          path='/sales-admin/merchants'
          component={ExtMerchants}
        ></PrivateRouteExt>
        <PrivateRouteExt
          exact
          authed={
            isLogged &&
            token.length > 0 &&
            auth.auth.userType === "EX-DSA-EXT-ADMIN"
          }
          path='/sales-admin/feedbacks'
          component={ExtFeedbacksPage}
        ></PrivateRouteExt>
        <PrivateRouteExt
          exact
          authed={
            isLogged &&
            token.length > 0 &&
            auth.auth.userType === "EX-DSA-EXT-ADMIN"
          }
          path='/sales-admin/referral'
          component={ExtReferral}
        ></PrivateRouteExt>
        <PrivateRouteExt
          exact
          authed={
            isLogged &&
            token.length > 0 &&
            auth.auth.userType === "EX-DSA-EXT-ADMIN"
          }
          path='/sales-admin/settings'
          component={ExtSettings}
        ></PrivateRouteExt>
      </Switch>
      <ApiLoader />
      <NotificationContainer />
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    isAuth: state.auth.token !== null,
    isLogged: state.auth.isLogged,
    email: state.auth.email,
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(App);
